import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/account/billing` is what the billing emails link to (`comms/templates/critical/
 * billing.tsx` — "Update your card" → `?recover=1`, "Reactivate and send" →
 * `?resume=<card_send_id>`), but the page has always lived at the legacy `/payment`
 * URL and this path never existed — every dunning CTA 404'd until 2026-09-16.
 * Redirect, search carried over; `_` keeps it out of the /account layout.
 */
export const Route = createFileRoute("/account_/billing")({
  beforeLoad: ({ search }) => {
    throw redirect({ to: "/payment", search, replace: true });
  },
});
